<template>
    <validation-observer ref="report">
        <b-row v-if="compactView">
            <b-col>
                <b-card bg-variant="default" border-variant="light">
                    <b-row>
                        <b-col>
                            <b-form-group :label="$t('Component(Verification):legislations-covered')">
                                <validation-provider
                                    #default="{ errors }"
                                    :name="$t('Component(Verification):legislations-covered')"
                                    rules="required"
                                >
                                    <v-select
                                        multiple
                                        v-model="report.legislations"
                                        :placeholder="$t('Component(Composition):placeholder-legislations')"
                                        :options="legislations"
                                        :getOptionLabel="(o) => o.title"
                                        @input="legislationChange"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group :label="$t('Component(Verification):type-of-document')">
                                <validation-provider
                                    #default="{ errors }"
                                    :name="$t('Component(Verification):type-of-document')"
                                    rules="required"
                                >
                                    <v-select
                                        multiple
                                        v-model="report.documentTypes"
                                        :placeholder="$t('Component(Composition):placeholder-document-types')"
                                        :options="types"
                                        :getOptionLabel="(o) => o.title"
                                        @input="documentTypesChange"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group :label="report.file.name ? $t('Component(File):uploaded-file') : $t('Component(File):upload-file')">
                                <div v-if="!isInputVisible" class="">
                                    <span class="d-flex">{{ report.file.name }}</span>
                                    <b-button
                                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                        variant="secondary"
                                        class="mt-0 mr-0 float-right"
                                        @click="reUpload"
                                    >
                                        {{ $t('Component(Button):re-upload') }}
                                    </b-button>

                                    <b-button
                                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                        variant="primary"
                                        class="mt-0 mr-1 sm float-right"
                                        :disabled="downloading"
                                        @click="download"
                                    >
                                        <b-spinner v-if="downloading" small />
                                        <feather-icon
                                            v-if="!downloading"
                                            icon="DownloadCloudIcon"
                                        />
                                    </b-button>

                                    <b-button
                                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                        variant="primary"
                                        class="mt-0 mr-1 sm float-right"
                                        @click="preview"
                                    >
                                        <feather-icon
                                            icon="EyeIcon"
                                        />
                                    </b-button>
                                </div>
                                <div v-if="isInputVisible" >
                                    <b-form-file
                                        v-model="report.document"
                                        :placeholder="$t('Component(Placeholder):choose-file-or-drop')"
                                        drop-placeholder="Drop file here..."
                                        accept="application/pdf,application/x-pdf"
                                        :class="{'w-75': report.id}"
                                        @input="documentChange"
                                    />
                                    <div class="cancel-button-container" v-if="report.id">
                                        <b-button
                                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                            variant="secondary"
                                            class="mt-0 mr-0 sm float-right"
                                            @click="cancel"
                                        >
                                            {{ $t('Component(Button):cancel') }}
                                        </b-button>
                                    </div>
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col md="5" lg="4">
                <b-form-group :label="$t('Component(Verification):legislations-covered')">
                    <validation-provider
                        #default="{ errors }"
                        :name="$t('Component(Verification):legislations-covered')"
                        rules="required"
                    >
                        <v-select
                            multiple
                            v-model="report.legislations"
                            :placeholder="$t('Component(Composition):placeholder-legislations')"
                            :options="legislations"
                            :getOptionLabel="(o) => o.title"
                            @input="legislationChange"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col md="4" lg="4">
                <b-form-group :label="$t('Component(Verification):type-of-document')">
                    <validation-provider
                        #default="{ errors }"
                        :name="$t('Component(Verification):type-of-document')"
                        rules="required"
                    >
                        <v-select
                            multiple
                            v-model="report.documentTypes"
                            :placeholder="$t('Component(Composition):placeholder-document-types')"
                            :options="types"
                            :getOptionLabel="(o) => o.title"
                            @input="documentTypesChange"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col md="3" lg="4">
                <b-form-group :label="report.file.name ? $t('Component(File):uploaded-file') : $t('Component(File):upload-file')">
                    <div v-if="!isInputVisible">
                        <div style="max-width: 158px !important; display: inline-block">{{ report.file.name }}</div>
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="secondary"
                            class="mt-0 mr-0 float-right"
                            @click="reUpload"
                        >
                            {{ $t('Component(Button):re-upload') }}
                        </b-button>

                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="mt-0 mr-1 sm float-right"
                            :disabled="downloading"
                            @click="download"
                        >
                            <b-spinner v-if="downloading" small />
                            <feather-icon
                                v-if="!downloading"
                                icon="DownloadCloudIcon"
                            />
                        </b-button>

                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="mt-0 mr-1 sm float-right"
                            @click="preview"
                        >
                            <feather-icon
                                icon="EyeIcon"
                            />
                        </b-button>
                    </div>
                    <div v-if="isInputVisible" >
                        <b-form-file
                            v-model="report.document"
                            :placeholder="$t('Component(Placeholder):choose-file-or-drop')"
                            drop-placeholder="Drop file here..."
                            accept="application/pdf,application/x-pdf"
                            :class="{'w-75': report.id}"
                            @input="documentChange"
                        />
                        <div class="cancel-button-container" v-if="report.id">
                            <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="secondary"
                                class="mt-0 mr-0 sm float-right"
                                @click="cancel"
                            >
                                {{ $t('Component(Button):cancel') }}
                            </b-button>
                        </div>
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
    </validation-observer>
</template>
<script>
import { BFormGroup, BFormDatepicker, BCard, BCardTitle, BRow, BCol, BFormFile, BButton, BSpinner } from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import {required} from '@validations'

export default {
    components: {
        BCard,
        BButton,
        BCardTitle,
        BRow,
        BCol,
        BFormGroup,
        BFormDatepicker,
        vSelect,
        BFormFile,
        BSpinner,
        ValidationProvider, ValidationObserver,
    },
    directives: {
        Ripple
    },
    props: {
        compactView: {
            type: Boolean,
            default: false,
        },

        legislations: {
            type: Array,
            default() {
                return [];
            }
        },

        types: {
            type: Array,
            default() {
                return [];
            }
        },

        report: {
            type: Object,
            default() {
                return {
                    id: null,
                    legislations: [],
                    documentTypes: [],
                    document: null,
                };
            }
        }
    },
    data() {
        return {
            downloading: false,
            showFileInput: !this.report.id,
            required,
        };
    },
    methods: {
        legislationChange() {
            this.notify();
        },
        documentTypesChange() {
            this.notify();
        },
        documentChange() {
            this.notify();
        },
        notify() {
            this.$refs.report.validate().then(valid => {
                if (valid || (this.report.id || this.report.document)) {
                    this.$emit('change', this.report);
                }
            });
        },
        reUpload() {
            this.showFileInput = true;
        },
        download() {
            this.downloading = true;
            this.$emit('download', this.report, () => {
                this.downloading = false;
            });
        },
        preview() {
            this.$emit('preview', this.report);
        },
        cancel() {
            this.showFileInput = false;
            this.report.document = null;
            this.notify();
        }
    },
    computed: {
        isInputVisible() {
            if (this.report.id && this.showFileInput) {
                return true;
            }
            return !this.report.id;
        }
    },
    watch: {
        report(value) {
            if (value.id && !value.document) {
                this.showFileInput = false;
            }
        }
    }
}
</script>
<style scoped>

</style>
